import { useLanguage } from '@/hooks/useLanguage'
import { FeatureFlag, useIsFlagEnabled } from '@/hooks/useIsFlagEnabled'
import { selectDMPConnectTlsiConnectorId } from '@/redux/reducers/dmp-connect.reducer'
import { useAppSelector } from '@/redux/rootReducer'

const VITALE_CARD_NOT_SUPPORTED_LANGUAGES = ['en', 'en-US', 'en-SA', 'ar-SA']

export function useVitaleCardDisplayLogic() {
  const language = useLanguage()

  const isDmpConnectEnabled = useIsFlagEnabled(FeatureFlag.DmpConnect)
  const tlsiConnectorId = useAppSelector(selectDMPConnectTlsiConnectorId)

  const isLanguageSupported = !VITALE_CARD_NOT_SUPPORTED_LANGUAGES.includes(language)
  // When the dmp-connect flag is off, behave as if no TLSi connector exists:
  // the platform vitale-card dialog takes over.
  const isDmpConnectorAvailable = isDmpConnectEnabled && !!tlsiConnectorId

  return {
    showDMPConnectVitaleCard: isLanguageSupported && isDmpConnectorAvailable,
    showPlatformVitaleCard: isLanguageSupported && !isDmpConnectorAvailable,
  }
}
